import React from 'react'
import classnames from 'classnames'
import { displayDollars } from '../../../../helpers/displayFormatHelper'
import RadioButton from '../../../../components/radioButton'
import { PaymentMode } from '../../../../core/types'

export interface PaymentFullOptionProps {
  isChecked: boolean
  total: number
  setPaymentOption: (option: PaymentMode) => void
}

export function PaymentFullOption({
  isChecked,
  total,
  setPaymentOption,
}: PaymentFullOptionProps) {
  const handleContainerClick = () => {
    setPaymentOption('full')
  }

  return (
    <div
      className={classnames('refi-payment-options__container', {
        'refi-payment-options__container--selected': isChecked,
      })}
      onClick={handleContainerClick}
      style={{ cursor: 'pointer' }}
    >
      <div className="refi-payment-options__title-container">
        <span className="refi-payment-options__title">Pay in full</span>
        <div className="refi-payment-options__title-left-section">
          <span>{displayDollars(total)}</span>
          <RadioButton
            checked={isChecked}
            name="payment-options"
            value="pay-in-full"
            iconSize="20px"
            uid="pay-in-full-checkbox"
            onChange={() => setPaymentOption('full')}
          />
        </div>
      </div>
    </div>
  )
}
